import { getRuntimeFeatureValues } from '../../utils/get-runtime-feature-values.js';
import { replaceCurrentRoute } from '../BookAppointment/utils.js';

var RoutingError;
(function(RoutingError) {
    RoutingError["INVALID_ROUTE"] = "INVALID_ROUTE";
    RoutingError["SERVER_SIDE_CONFIRMATION_ATTEMPT"] = "SERVER_SIDE_CONFIRMATION_ATTEMPT";
})(RoutingError || (RoutingError = {}));
const routingErrorHandler = (errorMessage, selfUrl, asPath, currentRoute, queryParams, publicRuntimeConfig, profileUrl)=>{
    const { myAccount  } = getRuntimeFeatureValues(publicRuntimeConfig);
    switch(errorMessage){
        case RoutingError.INVALID_ROUTE:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError.SERVER_SIDE_CONFIRMATION_ATTEMPT:
            const redirectUrl = myAccount && profileUrl ? `${selfUrl}${profileUrl}` : `${selfUrl}/`;
            return {
                type: 'redirect',
                url: redirectUrl
            };
        default:
            return {
                type: 'not-found'
            };
    }
};

export { RoutingError, routingErrorHandler };
//# sourceMappingURL=errors.js.map
